// Core
import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import route from 'ziggy'
import moment from 'moment'

moment.locale('da');

// Base setup
const el = document.getElementById('app');
InertiaProgress.init();

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {

        const vueApp = createApp({ render: () => h(app, props) })

        const Ziggy = {
            ...props.initialPage.props.ziggy,
            location: window.location
        }

        vueApp
            .mixin({
                methods: {
                    $route: (name, params, absolute, config = Ziggy) => route(name, params, absolute, config),
                    $date: (date, format = 'DD-MM-YYYY') => date ? moment(date).format(format) : '—',
                    $datetime: (date, format = 'DD-MM-YYYY HH:mm') => date ? moment(date).format(format) : '—',
                },
            })
            .mixin(require('../shared/access'))
            .mixin(require('../shared/translations'))
            .mixin(require('../shared/money'))
            .mixin(require('../shared/misc'))

        // 1: Relative path, 2: Recursive boolean, 3: Regex
        const requireLayout = require.context('./Layouts', false, /[A-Z]\w+\.(vue|js)$/);
        requireLayout.keys().forEach(fileName => {
            const layoutConfig = requireLayout(fileName);
            var fileName = fileName.split('/').pop().replace(/\.\w+$/, '') + 'Layout';
            vueApp.component(fileName, layoutConfig.default || layoutConfig);
        });

        const requireComponent = require.context('./Components', false, /[A-Z]\w+\.(vue|js)$/);
        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName);
            var fileName = fileName.split('/').pop().replace(/\.\w+$/, '');
            vueApp.component(fileName, componentConfig.default || componentConfig);
        });

        vueApp
            .use(plugin)
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mount(el)
    },
})
